import App from './App.vue'
import router from './router'
import store from './store'
import {createApp} from 'vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import '@fortawesome/fontawesome-free/css/all.css';
import BootstrapVueNext from 'bootstrap-vue-next'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 导入全局样式
import './assets/global.css'

// 抑制 ResizeObserver 错误
const debounce = (fn, delay) => {
  let timeoutId
  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn.apply(null, args), delay)
  }
}

const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 20)
    super(callback)
  }
}

// 全局错误处理
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation()
  }
})

// 确保DOM准备好后再创建Vue应用
const initializeApp = () => {
  const app = createApp(App)

  // Vue 应用级错误处理
  app.config.errorHandler = (err, vm, info) => {
    if (err.message && err.message.includes('ResizeObserver loop completed with undelivered notifications')) {
      return
    }
    console.error('Vue Error:', err, info)
  }

  // 注册所有图标
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

  app.use(ElementPlus, {
    locale: zhCn,
  })
  app.use(router)
  app.use(store)
  app.use(BootstrapVueNext)
  // 确保DOM元素存在后再挂载
  const mountElement = document.getElementById('app')
  if (mountElement) {
    app.mount('#app')
  } else {
    console.error('找不到#app元素')
  }
}

// 等待DOM准备好
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp)
} else {
  // DOM已经准备好
  initializeApp()
}
